import { h } from '@stencil/core';
import type { ObservableMap } from '@stencil/store';

import type { MatchStoreState } from '../../../../../services/interfaces';
import { calendarDateFormat } from '../../../../../services/libraries';
import { translateEntity } from '../../../../../services/utils';
import { getMatchWording, isFinishedMatch, setCssVariant } from '../../helpers';

import { MatchPostStatus } from './match-related';

type Props = {
  state: ObservableMap<MatchStoreState>['state'];
};

/**
 * Displays match-related bracket information including leg name and either kick-off time or match status
 * @param Props Component properties
 * @returns Stencil functional component
 */
const MatchRelatedBrackets = ({ state }: Props) => {
  const { dateCalendarFormat, customTimeZone, matchData: match, size } = state;
  if (!match) return null;

  const cssVariant = setCssVariant(size);
  const legName = translateEntity(match.leg)?.name;
  const isFinished = isFinishedMatch(match.status);
  const kickOffDateLocale = match.kickOffTime?.date
    ? calendarDateFormat(match.kickOffTime.date, dateCalendarFormat, customTimeZone)
    : '';

  return (
    <div class={{ 'pk-match__related--leg gap-xs2': true, ...cssVariant }} part="brackets">
      <span part="brackets-leg-name">{legName}</span>
      {isFinished ? (
        <span part="brackets-full-time">{getMatchWording('full_time')}</span>
      ) : (
        <span part="brackets-kick-off-date">{kickOffDateLocale}</span>
      )}
      {/* Will display the post status `Reason of win` of the match, e.g: `Bayern München win`  */}
      <MatchPostStatus state={state} />
    </div>
  );
};

export { MatchRelatedBrackets };
